/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState, useRef } from 'react'
import clsx from 'clsx'
import {
  toAbsoluteUrl,
  defaultMessages,
  defaultUserInfos,
  MessageModel,
  UserInfoModel,
  messageFromClient,
} from '../../helpers'
import { LanguageHelp } from '../../helpers/LanguageHelper';
import { formatDateWithTodayControl } from '../../helpers/utility';
import axios from 'axios'
import * as authHelper from '../../../app/modules/auth/core/AuthHelpers'

export interface ConversationMessageDto {
  user: number;
  text: string;
  translatedText?: string;
  sentiment: string;
  isSentimentUpdatedByHand: boolean;
  isSentimentAmbiguityExist: boolean;
  subjectList?: { value: string; label: string }[];
  tagList?: { value: string; label: string }[];
  direction: 'in' | 'out';
  createDate: string;
  updateDate: string;
  time: string
  template?: boolean

  messageType: number;
  senderType: number;
  senderId: string;
  senderUserName: string;
  senderEmail: string;
  senderFullName: string;
  senderProfileUrl: string;
  senderProfileImageUrl: string;

  // Video frame emotion analysis results
  videoFrameAnalyses?: ConversationMessage_VideoFrameAnalysesDto[];
}

interface EmotionScores {
  anger: number;
  disgust: number;
  fear: number;
  happiness: number;
  neutral: number;
  surprise?: number; // Opsiyonel veya diğer skorlar buraya eklenebilir
  [key: string]: number | undefined; // Esneklik payı bırakır
}
export interface ConversationMessage_VideoFrameAnalysesDto {
  frameBase64: string;
  dominantEmotion: string;
  dominantEmotionScore: number;
  emotionScores: EmotionScores;
  frameIndex: number;
  timestampSeconds: number;
}


type Props = {
  isDrawer?: boolean
  initialMessages: ConversationMessageDto[]
  conversationId?: string
  onMessageSent?: (msg: ConversationMessageDto) => void
  quickMessageList?: string[]
}

const ChatInner: FC<Props> = ({ isDrawer = false, initialMessages, conversationId, onMessageSent, quickMessageList = [] }) => {

  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [messages, setMessages] = useState<ConversationMessageDto[]>(initialMessages)
  const [isQuickMessageMenuOpen, setIsQuickMessageMenuOpen] = useState<boolean>(false)
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)
  const messagesEndRef = useRef<HTMLDivElement | null>(null)
  const messagesContainerRef = useRef<HTMLDivElement | null>(null)
  const quickMessageMenuRef = useRef<HTMLDivElement | null>(null)
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)


  useEffect(() => {
    setMessages(initialMessages)
  }, [initialMessages])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (quickMessageMenuRef.current && !quickMessageMenuRef.current.contains(event.target as Node)) {
        setIsQuickMessageMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Her zaman sadece chat kutusunun scroll'unu sona çek
  useEffect(() => {
    const container = messagesContainerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  }, [messages])

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px'
    }
  }, [message])



  const sendMessage = async () => {
    if (!conversationId || !message.trim()) return;
    try {

      const newMessage: ConversationMessageDto = {
        user: 2,
        direction: 'out',
        text: formatMessageHtml(message),
        time: LanguageHelp("Just now"),
        sentiment: '',
        isSentimentUpdatedByHand: false,
        isSentimentAmbiguityExist: false,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        messageType: 0,
        senderType: 0,
        senderId: '',
        senderUserName: LanguageHelp("You"),
        senderEmail: '',
        senderFullName: 'Siz',
        senderProfileUrl: '',
        senderProfileImageUrl: ''
      }
      setMessages([...messages, newMessage])
      setMessage('')
      if (textareaRef.current) { textareaRef.current.style.height = 'auto' }
      toggleChatUpdateFlat(!chatUpdateFlag)
      if (onMessageSent) onMessageSent(newMessage)

      const auth = authHelper.getAuth()

      var response = axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_URL}/conversation/sendMessage`,
        headers: {
          Authorization: 'Bearer ' + auth?.result.token //the token is a variable which holds the token
        },
        data: {
          conversationId: conversationId,
          message: message
        }
      })
        .then((response) => {
          if (response.data.httpStatusCode === 200) {
            return response.data.result.data;
          } else {
            return [];
          }
        })
      // .then((response: [any]) => response.map(function (item) { return { label: item.name, value: item.id, isParent: item.isParent }; }))
    } catch (e) {
      // Hata yönetimi
    }
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value)
    const el = e.target
    el.style.height = 'auto'
    el.style.height = el.scrollHeight + 'px'
  }

  const getQuickMessagePreview = (text: string): string => {
    if (!text) return ''
    return text.replace(/\n/g, ' ')
  }
  
  const formatMessageHtml = (rawText: string): string => {
    const textValue = String(rawText || '')
    if (!textValue) return ''

    // Keep existing HTML breaks as-is; otherwise convert line breaks for display.
    if (/<br\s*\/?>/i.test(textValue)) {
      return textValue
    }

    return textValue
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\n')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .replace(/\n/g, '<br />')
  }

  return (
    <div
      className='card-body'
      style={{ paddingBottom: '0px' }}
      id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
    >
      <div
        ref={messagesContainerRef}
        className={clsx('scroll-y me-n5 pe-5', { 'h-300px h-lg-auto': !isDrawer })}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-max-height='auto'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
        // style={{maxHeight: '335px'}}
        style={{ maxHeight: '475px' }}
      >
        {messages.map((message, index) => {
          // const userInfo = userInfos[message.user]
          const state = message.direction === 'in' ? 'info' : 'primary'
          const templateAttr = {}
          if (message.template) {
            Object.defineProperty(templateAttr, 'data-kt-element', {
              value: `template-${message.direction}`,
            })
          }
          const contentClass = `${isDrawer ? '' : 'd-flex'} justify-content-${message.direction === 'in' ? 'start' : 'end'
            } mb-10`

          // VideoFrameAnalyses: En yüksek emotionScore'u bul
          let topEmotion = null;
          if (message.videoFrameAnalyses && message.videoFrameAnalyses.length > 0) {
            topEmotion = message.videoFrameAnalyses.reduce((prev, curr) =>
              (curr.dominantEmotion > prev.dominantEmotion ? curr : prev)
            );
          }

          // Emotion ikon ve renk eşlemesi
          let emotionIconClass: string = '';
          let emotionColor: string = '';
          if (topEmotion) {
            switch (topEmotion.dominantEmotion) {
              case 'happiness':
                emotionIconClass = 'fa-solid fa-face-laugh-beam';
                emotionColor = 'text-success';
                break;
              case 'sadness':
                emotionIconClass = 'fa-solid fa-face-sad-tear';
                emotionColor = 'text-info';
                break;
              case 'anger':
                emotionIconClass = 'fa-solid fa-face-angry';
                emotionColor = 'text-danger';
                break;
              case 'fear':
                emotionIconClass = 'fa-solid fa-face-flushed';
                emotionColor = 'text-warning';
                break;
              case 'disgust':
                emotionIconClass = 'fa-solid fa-face-dizzy';
                emotionColor = 'text-success';
                break;
              case 'surprise':
                emotionIconClass = 'fa-solid fa-face-surprise';
                emotionColor = 'text-warning';
                break;
              case 'neutral':
              case 'natural':
                emotionIconClass = 'fa-solid fa-face-meh';
                emotionColor = 'text-secondary';
                break;
              default:
                emotionIconClass = 'fa-solid fa-face-meh';
                emotionColor = 'text-secondary';
            }
          }

          return (
            <div
              key={`message${index}`}
              className={clsx('d-flex', contentClass, 'mb-10', { 'd-none': message.template })}
              {...templateAttr}
            >
              <div
                className={clsx(
                  'd-flex flex-column align-items',
                  `align-items-${message.direction === 'in' ? 'start' : 'end'}`
                )}
              >
                <div className='d-flex align-items-center mb-2'>
                  {message.direction === 'in' ? (
                    <>
                      <div className='symbol  symbol-35px symbol-circle '>
                        {message?.senderProfileImageUrl !== null && message?.senderProfileImageUrl !== "" && (
                          <img alt={message.senderFullName} src={message.senderProfileImageUrl} />
                        )}
                        {(message?.senderProfileImageUrl === null || message?.senderProfileImageUrl === "") && (
                          <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                            {message?.senderFullName
                              ?.split(" ")
                              .filter(Boolean)
                              .slice(0, 2)
                              .map(word => word.charAt(0).toUpperCase())
                              .join("") || ""}
                          </span>
                        )}
                      </div>
                      <div className='ms-3'>
                        <a
                          href='#'
                          className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                        >
                          {message.senderFullName}
                        </a>
                        <span className='text-muted fs-7 mb-1'>{formatDateWithTodayControl(message.createDate)}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='me-3'>
                        <span className='text-muted fs-7 mb-1'>{formatDateWithTodayControl(message.createDate)}</span>
                      </div>
                      <div className='symbol  symbol-35px symbol-circle '>
                        {/* {message?.senderProfileImageUrl !== null && message?.senderProfileImageUrl !== "" && (
                          <img alt={message.senderFullName} src={message.senderProfileImageUrl} />
                        )}
                        {(message?.senderProfileImageUrl === null || message?.senderProfileImageUrl === "") && (
                          <span className='symbol-label bg-light-danger text-danger fs-6 fw-bolder'>
                            {message?.senderFullName
                              ?.split(" ")
                              .filter(Boolean)
                              .slice(0, 2)
                              .map(word => word.charAt(0).toUpperCase())
                              .join("") || ""}
                          </span>
                        )} */}
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={clsx(
                    'p-5 rounded',
                    `bg-light-${state}`,
                    'text-dark fw-bold mw-lg-400px',
                    `text-${message.direction === 'in' ? 'start' : 'end'}`
                  )}
                  data-kt-element='message-text'
                  dangerouslySetInnerHTML={{ __html: formatMessageHtml(message.text) }}
                ></div>

                {/* VideoFrameAnalyses: Emotion görseli ve ikon */}
                {topEmotion && (
                  <div className='d-flex align-items-center mt-2'>
                    <img
                      src={`data:image/jpeg;base64,${topEmotion.frameBase64}`}
                      alt={topEmotion.dominantEmotion}
                      style={{ width: 64, height: 64, borderRadius: 4, objectFit: 'cover', marginRight: 8 }}
                    />
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                      <i className={`${emotionIconClass} ${emotionColor}`} style={{ fontSize: 20, marginRight: 4 }}></i>
                      <span className={emotionColor} style={{ fontSize: 14 }}>{LanguageHelp(topEmotion.dominantEmotion)}</span>
                    </span>
                  </div>
                )}
              </div>
            </div>
          )
        })}
        {/* Scroll anchor */}
        <div ref={messagesEndRef} />
      </div>

      <div
        className='card-footer pt-4'
        style={{ paddingLeft: '0px', paddingRight: '0px' }}
        id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
      >
        <form className='w-100 d-flex align-items-center' onSubmit={e => { e.preventDefault(); sendMessage(); }}>
          <div className='me-3 position-relative' ref={quickMessageMenuRef}>
            <button
              type='button'
              className='btn btn-icon btn-sm btn-light-primary'
              onClick={() => setIsQuickMessageMenuOpen(prev => !prev)}
              disabled={quickMessageList.length === 0}
              title={quickMessageList.length === 0 ? LanguageHelp('Hızlı mesaj tanımı yok') : LanguageHelp('Hızlı mesajlar')}
              style={{ width: 36, height: 36 }}
            >
              <i className='bi bi-lightning-charge-fill fs-5' />
            </button>

            {isQuickMessageMenuOpen && quickMessageList.length > 0 && (
              <div
                className='menu menu-sub menu-sub-dropdown show w-275px p-2'
                style={{
                  position: 'absolute',
                  left: 0,
                  bottom: 'calc(100% + 8px)',
                  maxHeight: '260px',
                  overflowY: 'auto',
                  zIndex: 20
                }}
              >
                {quickMessageList.map((quickMessage, index) => (
                  <button
                    key={`${quickMessage}-${index}`}
                    type='button'
                    className='btn btn-sm btn-light w-100 text-start mb-1'
                    title={quickMessage}
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    onClick={() => {
                      const auth = authHelper.getAuth()
                      const agentFirstName = String(auth?.result?.name || '')
                      const resolved = agentFirstName
                        ? quickMessage.replace(/\{AgentName\}/g, agentFirstName)
                        : quickMessage
                      setMessage(resolved)
                      setIsQuickMessageMenuOpen(false)
                    }}
                  >
                    {getQuickMessagePreview(quickMessage)}
                  </button>
                ))}
              </div>
            )}
          </div>

          <textarea
            ref={textareaRef}
            className='form-control form-control-solid me-3'
            placeholder={LanguageHelp('Type a message')}
            value={message}
            rows={1}
            onChange={handleTextareaChange}
            onKeyDown={onEnterPress}
            style={{ resize: 'none', overflow: 'hidden', lineHeight: '1.5', minHeight: '42px', maxHeight: '200px' }}
          />
          <button
            type='submit'
            className='btn btn-primary'
            disabled={!message.trim()}
          >
            {LanguageHelp('Send')}
          </button>
        </form>
      </div>
    </div>
  )
}

export { ChatInner }
